export type TUtmParameters = {
  utmCampaign?: string
  utmSource?: string
  utmMedium?: string
  utmContent?: string
  utmTerm?: string
}

export enum EUtmParameters {
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_MEDIUM = 'utm_medium',
  UTM_SOURCE = 'utm_source',
  UTM_CONTENT = 'utm_content',
  UTM_TERM = 'utm_term',
}
